import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { InfoPayload } from 'src/app/models/info/info-payload.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class InfoService {

	private baseInfoUrl = `${environment.baseUrl}/info`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getInfoDetails(token: string): Observable<InfoPayload> {
		return this.httpClient.get<InfoPayload>(`${this.baseInfoUrl}/${token}`);
	}
}
